export default __webpack_public_path__ + "static/media/878.862ed921.gif";